/** The cells of a tile layer that Godot draws, each with the source, tile and tile data it draws with. */
import { alternativeNoTransform, } from './types';
/**
 * The cells Godot draws, in the order given. `_rendering_quadrants_update_cell` places a cell in no
 * quadrant unless its source, tile and alternative exist (`tile_map_layer.cpp:527-531`).
 */
export function drawableCells(model, cells) {
    const drawable = [];
    for (const cell of cells) {
        const source = model.sources.get(cell.sourceId);
        const tile = source?.tiles.get(`${cell.atlasCoords.x}:${cell.atlasCoords.y}`);
        const tileData = tile?.alternatives.get(alternativeNoTransform(cell.alternativeId));
        if (source && tile && tileData)
            drawable.push({ ...cell, source, tile, tileData });
    }
    return drawable;
}
//# sourceMappingURL=drawableCell.js.map